import { getProviderHook } from './PMHooks';

export const useGetExtraDataPerProvider = ({
  entity_name,
  rawData = [],
  sensor_authorization_id,
  sensorName,
  chunkSize,
  cachePolicy
}) => {
  const providerHook = getProviderHook(sensorName);
  if (providerHook) {
    return providerHook({
      entity_name,
      rawData,
      sensor_authorization_id,
      sensorName,
      chunkSize,
      cachePolicy
    });
  }
  return [];
};
